import { jsx as r } from "react/jsx-runtime";
import { useMemo as s } from "react";
import m from "../TabListLayout/index.js";
import b from "../../contexts/navigation-tab.js";
function c(i) {
  const {
    styleVariant: t = "tab",
    colorVariant: a = t === "tab" ? "text" : "primary",
    disabled: o,
    ...e
  } = i, n = s(
    () => ({
      colorVariant: a,
      styleVariant: t,
      disabled: o
    }),
    [t, a, o]
  );
  return /* @__PURE__ */ r(b.Provider, { value: n, children: /* @__PURE__ */ r(
    m,
    {
      ...e,
      styleVariant: t,
      colorVariant: a,
      disabled: o
    }
  ) });
}
export {
  c as default
};
